import { create } from 'zustand';
import { readStorage, writeStorage } from '../lib/storage';

export type Theme = 'light' | 'dark';
export const THEME_KEY = 'xq-crm-theme';

function systemTheme(): Theme {
  try {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function initialTheme(): Theme {
  const saved = readStorage(THEME_KEY);
  return saved === 'dark' || saved === 'light' ? saved : systemTheme();
}

function apply(theme: Theme): void {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('data-theme', theme);
}

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: initialTheme(),
  setTheme: (theme) => {
    writeStorage(THEME_KEY, theme);
    apply(theme);
    set({ theme });
  },
  toggle: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
}));

apply(useTheme.getState().theme);
